import { useEffect, useRef } from "react";

export default function useUsersRolesDialog({ rootRef, dialogKey, onClose, busy }) {
  const latest = useRef({ onClose, busy });
  latest.current = { onClose, busy };
  useEffect(() => {
    if (!dialogKey) return undefined;
    const dialogs = rootRef.current?.querySelectorAll(".ur-modal");
    const dialog = dialogs?.[dialogs.length - 1];
    if (!dialog) return undefined;
    const previousFocus = document.activeElement;
    dialog.focus({ preventScroll: true });
    const focusable = () => [...dialog.querySelectorAll('button, input, select, textarea, a[href], [tabindex]')].filter((element) => {
      if (element.matches(':disabled') || element.tabIndex < 0 || element.closest('[hidden], [inert], [aria-hidden="true"]')) return false;
      for (let node = element; node; node = node.parentElement) {
        const style = window.getComputedStyle(node);
        if (style.display === "none" || style.visibility === "hidden") return false;
      }
      return true;
    });
    const onKeyDown = (event) => {
      if (event.defaultPrevented) return;
      if (event.key === "Escape") {
        event.preventDefault();
        event.stopPropagation();
        if (!latest.current.busy) latest.current.onClose();
      } else if (event.key === "Tab") {
        const elements = focusable();
        const first = elements[0] || dialog;
        const last = elements[elements.length - 1] || dialog;
        if (!elements.includes(document.activeElement) || (event.shiftKey ? document.activeElement === first : document.activeElement === last)) {
          event.preventDefault();
          (event.shiftKey ? last : first).focus();
        }
      }
    };
    const onFocusIn = (event) => { if (!dialog.contains(event.target)) dialog.focus({ preventScroll: true }); };
    document.addEventListener("keydown", onKeyDown);
    document.addEventListener("focusin", onFocusIn);
    return () => {
      document.removeEventListener("keydown", onKeyDown);
      document.removeEventListener("focusin", onFocusIn);
      if (previousFocus?.isConnected) previousFocus.focus({ preventScroll: true });
    };
  }, [dialogKey, rootRef]);
}
